import { useEffect, useState } from 'react';
import { searchAdUsersByName } from '../../utils/principal-service/user-endpoints';
import { BaseUserType } from '../../utils/types';

export const useAdUsersByName = (
  searchTerm: string | undefined,
): BaseUserType[] | undefined => {
  const [adUsers, setAdUsers] = useState<BaseUserType[]>();

  useEffect(() => {
    if (!searchTerm) return;
    setAdUsers(undefined);
    searchAdUsersByName(searchTerm).then(({ data }) => {
      setAdUsers(data?.results);
    });
  }, [searchTerm]);
  return adUsers;
};
